import React, { useEffect, useState, useMemo } from 'react';
import Container from '../../../Container/Container'
import { useNavigate, useLocation, Link } from 'react-router';
import { useForm, Controller } from "react-hook-form";
import { get, ImageUrl } from '../../../ApiServices/ApiServices';
import Select from 'react-select';
import 'react-toastify/dist/ReactToastify.css';
import { Image } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { setSize, clearSize, setShirtSize } from '../../../redux/profileSlice';
import { useDebounce } from 'use-debounce';
import { Search } from "lucide-react";



function GroomsmenStyleDetail({ onSubmit, onNext, onBack, ticket, initialValues }) {
    const { register, handleSubmit, formState: { errors }, control, watch, getValues, trigger, setValue } = useForm({
        defaultValues: initialValues
    });

    const [data, setdata] = useState([])
    const CoatstyleData = JSON.parse(localStorage.getItem('GroomMencoatStyle'));
    const [Coatstyle, setCoatstyle] = useState(CoatstyleData || null)
    const pantstyleData = JSON.parse(localStorage.getItem('GroomMenpantstyle'));
    const [Pantstyle, setPantstyle] = useState(pantstyleData || null)
    const shirtstyleData = JSON.parse(localStorage.getItem('GroomMenshirtstyle'));
    const [Shirtstyle, setShirtstyle] = useState(shirtstyleData || null)
    const VeststyleData = JSON.parse(localStorage.getItem('GroomMenVeststyle'));
    const [Veststyle, setVeststyle] = useState(VeststyleData || null)
    const ShoesData = JSON.parse(localStorage.getItem('GroomMenshoestyle'));
    const [Shoesstyle, setShoesstyle] = useState(ShoesData || null);

    const [pantStyleSelected, setPantStyleSelected] = useState(false);
    const selectedCoatStyle = watch("Coat");
    const selectedVestStyle = watch("Vest");
    const selectedShoesStyle = watch("Shoes");
    const pantStyleValue = watch("Pant");


    const [LebelCoat, setLebelCoat] = useState(CoatstyleData || null)
    const [Lebelpant, setLebelpant] = useState(pantstyleData || null)
    const [LebelShirt, setLebelShirt] = useState(shirtstyleData || null)
    const [LebelVest, setLebelVest] = useState(VeststyleData || null)
    const [LebelShoes, setLebelShoes] = useState(selectedShoesStyle || null)


    const Resize = useSelector((state) => state.profile.size);
    const navigate = useNavigate()
    const location = useLocation()
    const [selectedCoatStyleForPants, setSelectedCoatStyleForPants] = useState(null);


    const [activeItem, setActiveItem] = useState(1);


    const [openItems, setOpenItems] = useState({
        1: true,
        2: false,
        3: false,
    })

    const toggleItem = (id) => {
        // If clicked on currently active item, close it (set to null)
        // Otherwise, open the clicked item and close others
        setActiveItem(prevActive => prevActive === id ? null : id);
    };



    const AccordionItem = ({ id, title, children }) => {
        const [isHovered, setIsHovered] = useState(false);
        const isActive = activeItem === id;

        return (
            <div className="accordion-item">
                <button
                    className={`accordion-button ${isActive ? 'active' : ''}`}
                    onClick={() => toggleItem(id)}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                >
                    <span>{title}</span>
                    <span className="accordion-icon">{isActive ? <em class="icon ni ni-upword-ios"></em> : <em class="icon ni ni-downward-ios"></em>}</span>
                </button>
                {isActive && <div className="accordion-content">{children}</div>}
            </div>
        );
    };




    const handleBack = () => {
        const currentValues = getValues();
        onBack(currentValues);
    };
    const ViewState = async () => {
        try {
            const api = `all-inventories?size=${1000}`;
            const response = await get(api);
            if (response?.status == true) {
                setdata(response.data?.rows);
            }
        } catch (err) {
            if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
                localStorage.removeItem('token');
                navigate('/login');
            }
            console.error('Errordsfdsfd:', err);
        } finally {
        }
    };
    useEffect(() => {
        ViewState();
    }, []);

    // First filter all the data
    const category1Data = data?.filter((item) => item.category_id === 1);
    const pants = data?.filter((item) => item.category_id === 2);
    const Shirt = data?.filter((item) => item.category_id === 3);
    const Vest = data?.filter((item) => item.category_id === 4);
    const Tie = data?.filter((item) => item.category_id === 5);
    const Shoes = data?.filter((item) => item.category_id === 7);
    const Pocket = data?.filter((item) => item.category_id === 8);
    const Jewelry = data?.filter((item) => item.category_id === 9);

    // Then create options from filtered data
    const options = category1Data.map(item => ({
        value: item.style,
        label: `${item.style} ${item.description}`
    }));

    // Now create sorted versions
    const sortedOptions = [...options].sort((a, b) => a.label.localeCompare(b.label, undefined, { numeric: true }));
    const sortedPants = [...pants].sort((a, b) =>
        a.style.localeCompare(b.style, undefined, { numeric: true })
    );
    const sortedShirts = [...Shirt].sort((a, b) =>
        a.style.localeCompare(b.style, undefined, { numeric: true })
    );
    const sortedVest = [...Vest].sort((a, b) =>
        a.style.localeCompare(b.style, undefined, { numeric: true })
    );
    const sortedTie = [...Tie].sort((a, b) =>
        a.style.localeCompare(b.style, undefined, { numeric: true })
    );
    const sortedPocketSquare = [...Pocket].sort((a, b) =>
        a.style.localeCompare(b.style, undefined, { numeric: true })
    );
    const sortedJewelry = [...Jewelry].sort((a, b) =>
        a.style.localeCompare(b.style, undefined, { numeric: true })
    );
    const sortedShoes = [...Shoes].sort((a, b) =>
        a.style.localeCompare(b.style, undefined, { numeric: true })
    );

    const customComponents = {
        DropdownIndicator: (props) => (
            <div {...props} style={{ padding: "5px", display: "flex", alignItems: "center" }}>
                <Search size={16} />
            </div>
        ),
    };

    const handlejwellaryChange = (e) => {
        const selectedStyle = Jewelry.find(item => item.style === e.target.value);
        if (selectedStyle) {
            setValue("GroomMenjewelryinventory_id", selectedStyle.id);
        }
    }

    const handleTie = (e) => {
        const selectedStyle = Tie.find(item => item.style == e.target.value);
        if (selectedStyle) {
            setValue("GroomMenTieInventory_id", selectedStyle.id);
        }
    }

    const handlePocket = (e) => {
        const selectedPocketString = e.target.value;
        const selectedStyle = Pocket.find(item => `${item.style}` == selectedPocketString);

        if (selectedStyle) {
            setValue("GroomMenPocketInventory_id", selectedStyle.id);
            setValue("GroomMenPocket", e.target.value, { shouldValidate: true });
        } else {
            console.error("Selected pocket style not found in Pocket array.");
        }
    };

    const handleCoatChange = (selectedOption) => {
        if (selectedOption) {
            const selectedStyle = category1Data.find(item => item.style === selectedOption.value);
            const serializedData = JSON.stringify(selectedStyle);
            localStorage.setItem('GroomMencoatStyle', serializedData);
            setValue("GroomMencoatinventory_id", selectedStyle.id);
            setCoatstyle(selectedStyle);
            setSelectedCoatStyleForPants(selectedStyle.style);

        } else {
            setCoatstyle(null);
            localStorage.removeItem('GroomMencoatStyle');
            setValue("GroomMencoatinventory_id", "");
            setSelectedCoatStyleForPants(null);


        }
    };

    const handlePaintChange = (e) => {
        const selectedStyleString = e.target.value;
        const selectedStyle = pants.find(item => `${item.style}` == selectedStyleString);

        if (selectedStyle) {
            setValue("GroomMenPaintinventory_id", selectedStyle.id);
            setPantstyle(selectedStyle);
            const serializedData = JSON.stringify(selectedStyle);
            localStorage.setItem('GroomMenpantstyle', serializedData);
            setValue("GroomMenPant", e.target.value, { shouldValidate: true });
        } else {
            localStorage.removeItem('GroomMenpantstyle');
            setValue("GroomMenPaintinventory_id", "");
            setPantstyle(null);

        }
    };

    const handleShirtChange = (e) => {
        const selectedShirtString = e.target.value;
        const selectedShirt = sortedShirts.find(item => `${item.style}` == selectedShirtString);

        if (selectedShirt) {
            setValue("GroomMenshirtInventory_id", selectedShirt.id);
            const serializedData = JSON.stringify(selectedShirt);
            setShirtstyle(selectedShirt)
            localStorage.setItem('GroomMenshirtstyle', serializedData);
            setValue("GroomMenShirt", e.target.value, { shouldValidate: true });
        } else {
            setValue("GroomMenshirtInventory_id", "");
            localStorage.removeItem('GroomMenshirtstyle');
            setValue("GroomMenShirt", "");
            setShirtstyle(null)

            console.error("Selected shirt not found in shirts array.");
        }
    };

    const handleVestChange = (e) => {
        const selectedStyle = Vest.find(item => item.style == e.target.value) || null;
        setValue("GroomMenVest", e.target.value, { shouldValidate: true });

        if (selectedStyle) {
            localStorage.setItem('GroomMenVeststyle', JSON.stringify(selectedStyle));
            setValue("GroomMenVestInventory_id", selectedStyle.id);
            setVeststyle(selectedStyle);
        } else {
            setValue("GroomMenVest", "");
            localStorage.removeItem('GroomMenVeststyle');
            setValue("GroomMenVestInventory_id", "");
            setVeststyle(null);
        }
    };

    const handleShoes = (e) => {
        const selectedShoesString = e.target.value;
        const selectedStyle = Shoes.find(item => `${item.style}` == selectedShoesString);

        if (selectedStyle) {
            setValue("GroomMenShoesInventory_id", selectedStyle.id);
            setShoesstyle(selectedStyle)
            setValue("GroomMenShoes", e.target.value, { shouldValidate: true });
        } else {
            console.error("Selected shoes not found in Shoes array.");
            setShoesstyle("")
        }
    };

    const fetchInventoryDatatwi = async () => {
        try {
            const api = `all-inventory-categories`;
            const totalData = await get(api);
        } catch (err) {
            if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
                localStorage.removeItem('token');
                navigate('/login');
            }
        } finally {
        }
    };

    useEffect(() => {
        fetchInventoryDatatwi()
    }, [])


    // GroomMenCoat: "",
    // GroomMenPant: "",
    // GroomMenShirt: "",
    // GroomMenVest: "",
    // GroomMenTie: "",
    // GroomMenPocket: "",
    // GroomMenJewelry: "",
    // GroomMenShoes: "",
    // GroomMenRentalterm: "",
    // GroomMenorder_for: "",


    const styles = {
        accordionContainer: {
            width: '100%',
            maxWidth: '600px',
            margin: '0 auto',
        },
        heading: {
            fontSize: '24px',
            fontWeight: 'bold',
            marginBottom: '16px',
        },
        accordionItem: {
            border: '1px solid #dee2e6',
            borderRadius: '4px',
            marginBottom: '8px',
        },
        accordionButton: {
            width: '100%',
            padding: '16px',
            textAlign: 'left',
            backgroundColor: '#f8f9fa',
            border: 'none',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            cursor: 'pointer',
            fontWeight: '500',
        },
        accordionButtonActive: {
            backgroundColor: '#d0e8ff', // Light blue color for active accordion
            borderBottom: '1px solid #bee3f8',
        },
        accordionButtonHover: {
            backgroundColor: '#e9ecef',
        },
        accordionIcon: {
            fontSize: '20px',
        },
        accordionContent: {
            padding: '16px',
        },
        paragraph: {
            margin: '0 0 8px 0',
        },
        list: {
            paddingLeft: '20px',
            marginTop: '8px',
            listStyleType: 'disc',
        },
        infoBox: {
            marginTop: '12px',
            padding: '12px',
            backgroundColor: '#e7f5ff',
            borderRadius: '4px',
        }
    };

    useEffect(() => {
        if (activeItem != 1) {
            setLebelCoat(CoatstyleData)
        }
        if (activeItem != 2) {
            setLebelpant(pantstyleData)
        }
        if (activeItem != 3) {
            setLebelShirt(shirtstyleData)
        }
        if (activeItem != 4) {
            setLebelVest(VeststyleData)
        }
        if (activeItem != 6) {
            setLebelShoes(Shoesstyle)
        }
    }, [activeItem])

    const getSortedPantsOptions = () => {
        const baseOptions = sortedPants.map(item => {
            const isExact = item.style === selectedCoatStyleForPants;
            const isPartial = item.style.includes(selectedCoatStyleForPants);

            return {
                value: item.style,
                label: (
                    <span style={{ fontWeight: isExact || isPartial ? 'bold' : 'normal' }}>
                        {item.style} {item.description}
                    </span>
                ),
                sortValue: item.style, // for sorting fallback
                isExact,
                isPartial
            };
        });

        // Sorting: Exact match > Partial match > Nearest higher > Others
        const sorted = baseOptions.sort((a, b) => {
            if (a.isExact) return -1;
            if (b.isExact) return 1;
            if (a.isPartial && !b.isPartial) return -1;
            if (!a.isPartial && b.isPartial) return 1;

            const selected = parseInt(selectedCoatStyleForPants);
            const aStyle = parseInt(a.sortValue);
            const bStyle = parseInt(b.sortValue);

            // Put nearest higher style (like 130 after 125) earlier
            const aDiff = aStyle > selected ? aStyle - selected : Infinity;
            const bDiff = bStyle > selected ? bStyle - selected : Infinity;

            return aDiff - bDiff;
        });

        return sorted;
    };


    return (
        <Container>
            <div class="nk-content ">
                <div class="container-fluid">
                    <div class="nk-content-inner">
                        <div class="nk-content-body">
                            <div class="nk-block-head nk-block-head-sm">
                                <div class="nk-block-between">
                                    <div class="nk-block-head-content">
                                        <h3 class="nk-block-title page-title">{location.pathname == "/add-wedding-order" ? "Add" : "Update"}  Weddings Event {(ticket && location.pathname != "/add-order") && `#${ticket}`}</h3></div>

                                </div>
                            </div>

                            <div class="card card-full">
                                <div class="card-inner">
                                    <div class="stepperLeft">
                                        <div className="row">
                                            <div className="col-md-4 brIght">
                                                <section className="section1">
                                                    <header>
                                                        <div className="bead complete"><span><i class="fa-solid fa-check"></i></span></div> {location.pathname == "/add-wedding-order" ? "Add" : "Update"}  Groom Detail
                                                    </header>
                                                </section>
                                                <section className="section2">
                                                    <header>
                                                        <div className="bead complete"><span><i class="fa-solid fa-check"></i></span></div>{location.pathname == "/add-wedding-order" ? "Add" : "Update"}  Bride Detail
                                                    </header>
                                                </section>
                                                <section className="section2">
                                                    <header>
                                                        <div className="bead current"><span><i class="fa-solid fa-check"></i></span></div> Groom Style Detail
                                                    </header>
                                                </section>
                                                <section className="section2">
                                                    <header>
                                                        <div className="bead current"><span>4</span></div> Groomsmen Style Detail
                                                    </header>
                                                </section>
                                                <section>
                                                    <header>
                                                        <div className="bead"><span>5</span></div> {location.pathname == "/add-wedding-order" ? "Add" : "Update"} Description
                                                    </header>
                                                </section>
                                            </div>

                                            <div className="col-md-8">
                                                <div className="row">
                                                    <div className="d-flex align-items-center justify-content-between w-100 ">
                                                        <h4> Groomsmen Style Detail</h4>
                                                    </div></div>
                                                <form onSubmit={handleSubmit(onNext)}>
                                                    <div className="inputCardBox mt-4">
                                                        <div className="col-md-12">
                                                            <div className="newAccordion">
                                                                <div className={"accordionContainer"}>

                                                                    <AccordionItem
                                                                        id={1}
                                                                        // title="Coat Style"
                                                                        title={
                                                                            LebelCoat?.style ? (
                                                                                <span className="fw-400">
                                                                                    <strong className="fw-700">Coat Style</strong> ({LebelCoat?.style} {LebelCoat?.description} )
                                                                                </span>
                                                                            ) : (
                                                                                <span><strong className="fw-700">Coat Style</strong></span>
                                                                            )
                                                                        }
                                                                    >
                                                                        <div className="accordion-inner">
                                                                            <div className="row">
                                                                                <div className="col-md-8 p-0 stateSelect">
                                                                                    <div className="row">
                                                                                        <div className="col-md-6 mb-3">
                                                                                            <label>Coat Style<span className="text-red-500"></span></label>
                                                                                            <Controller
                                                                                                name="GroomMenCoat"
                                                                                                control={control}
                                                                                                // rules={{ required: "Coat is required" }}
                                                                                                render={({ field }) => (
                                                                                                    <Select
                                                                                                        {...field}
                                                                                                        // options={options}
                                                                                                        options={sortedOptions}
                                                                                                        placeholder="Select"
                                                                                                        components={customComponents}
                                                                                                        isClearable
                                                                                                        onChange={(selectedOption) => {
                                                                                                            field.onChange(selectedOption ? selectedOption.value : '');
                                                                                                            handleCoatChange(selectedOption);
                                                                                                        }}
                                                                                                        value={options.find(option => option.value === field.value) || null}

                                                                                                    />
                                                                                                )}
                                                                                            />
                                                                                            {errors.Coat && <p className='red'>{errors.Coat.message}</p>}
                                                                                        </div>
                                                                                        <div className="col-md-6 mb-3">
                                                                                            <h6 className="mb-0 mt-1">{Coatstyle?.style ? `#${Coatstyle.style} ` : ''}</h6>
                                                                                            <p className="coatTxtPra"><small>{Coatstyle?.description}</small></p>
                                                                                        </div>
                                                                                        <div >
                                                                                            <a href="" data-bs-toggle="modal" data-bs-target="#alterationsCoatModal"></a>
                                                                                        </div>
                                                                                    </div >
                                                                                </div >

                                                                                <div className="col-md-4 addStyleMobileImg">
                                                                                    {Coatstyle?.image ? (
                                                                                        <Image src={`${ImageUrl}${Coatstyle?.image}`} className="noSelectCoatImg" alt="" />
                                                                                    ) : (
                                                                                        <img src="/assets/images/no-photo.png" className="selectCoatImg" alt="" />
                                                                                    )}
                                                                                </div>
                                                                            </div >
                                                                        </div >
                                                                    </AccordionItem>
                                                                    <AccordionItem
                                                                        id={2}
                                                                        // title="Pant Style"
                                                                        title={
                                                                            Lebelpant?.style ? (
                                                                                <span className="fw-400">
                                                                                    <strong className="fw-700">Pant Style</strong> ({Lebelpant?.style} {Lebelpant?.description})
                                                                                </span>
                                                                            ) : (
                                                                                <span><strong className="fw-700">Pant Style</strong></span>
                                                                            )
                                                                        }
                                                                    >
                                                                        <div className="accordion-inner">
                                                                            <div className="row">
                                                                                <div className="col-md-8 p-0 stateSelect">
                                                                                    <div className="row">
                                                                                        {/* Pant Style Field */}
                                                                                        <div className="col-md-6 mb-3">
                                                                                            <label>Pant Style<span className="text-red-500"></span></label>
                                                                                            <Controller
                                                                                                name="GroomMenPant"
                                                                                                control={control}
                                                                                                // rules={{ required: "Pant is required" }}
                                                                                                render={({ field }) => (
                                                                                                    <Select
                                                                                                        {...field}
                                                                                                        // options={sortedPants.map(item => ({
                                                                                                        //     value: `${item.style}`, // Combined value
                                                                                                        //     label: `${item.style} ${item.description}` // Combined label
                                                                                                        // }))}
                                                                                                        options={getSortedPantsOptions()}

                                                                                                        placeholder="Select"
                                                                                                        components={customComponents}
                                                                                                        isClearable
                                                                                                        onChange={(selectedOption) => {
                                                                                                            const selectedValue = selectedOption ? selectedOption.value : '';
                                                                                                            field.onChange(selectedValue); // Update form value
                                                                                                            const syntheticEvent = { target: { value: selectedValue } };
                                                                                                            handlePaintChange(syntheticEvent); // Trigger change handler
                                                                                                        }}
                                                                                                        // value={sortedPants.map(item => ({
                                                                                                        //     value: `${item.style}`,
                                                                                                        //     label: `${item.style} ${item.description}`
                                                                                                        // })).find(option => option.value === field.value) || null}
                                                                                                        value={getSortedPantsOptions().find(option => option.value === field.value) || null}

                                                                                                    />
                                                                                                )}
                                                                                            />
                                                                                            {errors.Pant && <p className='red'>{errors.Pant.message}</p>}
                                                                                        </div>

                                                                                        {/* Display Pant Style Details */}
                                                                                        <div className="col-md-6 mb-3">
                                                                                            <h6 className="mb-0 mt-1">{Pantstyle?.style ? `#${Pantstyle.style}` : ''}</h6>
                                                                                            <p className="coatTxtPra"><small>{Pantstyle?.description}</small></p>
                                                                                        </div>


                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-md-4 addStyleMobileImg">
                                                                                    {Pantstyle?.image ? (
                                                                                        <Image src={`${ImageUrl}${Pantstyle?.image}`} className="noSelectCoatImg" alt="" />
                                                                                    ) : (
                                                                                        <img src="/assets/images/no-photo.png" className="selectCoatImg" alt="" />
                                                                                    )}
                                                                                </div>

                                                                            </div>
                                                                        </div>
                                                                    </AccordionItem>
                                                                    <AccordionItem
                                                                        id={3}
                                                                        // title="Shirt Style"
                                                                        title={
                                                                            LebelShirt?.style ? (
                                                                                <span className="fw-400">
                                                                                    <strong className="fw-700">Shirt Style</strong> ({LebelShirt?.style} {LebelShirt?.description})                                                                                </span>
                                                                            ) : (
                                                                                <span><strong className="fw-700">Shirt Style</strong></span>
                                                                            )
                                                                        }
                                                                    >
                                                                        <div class="accordion-inner">
                                                                            <div className="row">
                                                                                <div className="col-md-8 p-0 stateSelect">
                                                                                    <div className="row">
                                                                                        <div className="col-md-6 mb-3">
                                                                                            <label>Shirt Style<span className="text-red-500"></span></label>
                                                                                            <Controller
                                                                                                name="GroomMenShirt"
                                                                                                control={control}
                                                                                                // rules={{ required: "Shirt is required" }}
                                                                                                render={({ field }) => (
                                                                                                    <Select
                                                                                                        {...field}
                                                                                                        options={sortedShirts.map(item => ({
                                                                                                            value: `${item.style}`, // Combined value
                                                                                                            label: `${item.style} ${item.description}` // Combined label
                                                                                                        }))}
                                                                                                        placeholder="Select"
                                                                                                        components={customComponents}
                                                                                                        isClearable
                                                                                                        onChange={(selectedOption) => {
                                                                                                            const selectedValue = selectedOption ? selectedOption.value : '';
                                                                                                            field.onChange(selectedValue); // Update react-hook-form value
                                                                                                            const syntheticEvent = { target: { value: selectedValue } };
                                                                                                            handleShirtChange(syntheticEvent);
                                                                                                        }}
                                                                                                        value={sortedShirts.map(item => ({
                                                                                                            value: `${item.style}`,
                                                                                                            label: `${item.style} ${item.description}`
                                                                                                        })).find(option => option.value === field.value) || null}
                                                                                                    />
                                                                                                )}
                                                                                            />
                                                                                            {errors.Shirt && <p className='red'>{errors.Shirt.message}</p>}
                                                                                        </div>
                                                                                        <div className="col-md-6 mb-3">
                                                                                            <h6 className="mb-0 mt-1">{Shirtstyle?.style ? `#${Shirtstyle?.style}` : ''}</h6>
                                                                                            <p className="coatTxtPra"><small>{Shirtstyle?.description}</small></p>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-md-4 addStyleMobileImg">
                                                                                    {
                                                                                        shirtstyleData?.image ? <Image src={`${ImageUrl}${shirtstyleData?.image}`} className="noSelectCoatImg" alt="" />
                                                                                            : <img src="/assets/images/no-photo.png" className="selectCoatImg" alt />

                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                    </AccordionItem>
                                                                    <AccordionItem
                                                                        id={4}
                                                                        // title="Vest Style"
                                                                        title={
                                                                            LebelVest?.style ? (
                                                                                <span className="fw-400">
                                                                                    <strong className="fw-700">Vest Style</strong> ({LebelVest?.style} {LebelVest?.description})                                                                                </span>
                                                                            ) : (
                                                                                <span><strong className="fw-700">Vest Style</strong></span>
                                                                            )
                                                                        }
                                                                    >
                                                                        <div class="accordion-inner">
                                                                            <div className="row">
                                                                                <div className="col-md-12 p-0 stateSelect">
                                                                                    <div className="row">
                                                                                        <div className="col-md-8 mb-3">
                                                                                            <div className="row">
                                                                                                <div className="col-md-6 mb-3">
                                                                                                    <label>Vest Style <span className="text-red-500"></span></label>
                                                                                                    <Controller
                                                                                                        name="GroomMenVest"
                                                                                                        control={control}
                                                                                                        render={({ field }) => (
                                                                                                            <Select
                                                                                                                {...field}
                                                                                                                options={sortedVest.map(item => ({
                                                                                                                    value: item.style,
                                                                                                                    label: `${item.style} ${item.description}`
                                                                                                                }))}
                                                                                                                placeholder="Select"
                                                                                                                components={customComponents}
                                                                                                                isClearable
                                                                                                                onChange={(selectedOption) => {
                                                                                                                    field.onChange(selectedOption ? selectedOption.value : '');
                                                                                                                    const syntheticEvent = { target: { value: selectedOption ? selectedOption.value : '' } };
                                                                                                                    handleVestChange(syntheticEvent);

                                                                                                                }}
                                                                                                                value={Vest.map(item => ({
                                                                                                                    value: item.style,
                                                                                                                    label: `${item.style} ${item.description}`
                                                                                                                })).find(option => option.value === field.value) || null}
                                                                                                            />
                                                                                                        )}
                                                                                                    />
                                                                                                    {errors.Vest && <p className='red'>{errors.Vest.message}</p>}
                                                                                                </div>

                                                                                                <div className="col-md-6 mb-3">
                                                                                                    <h6 className="mb-0 mt-1">{Veststyle?.style ? `#${Veststyle?.style}` : ''}</h6>
                                                                                                    <p className="coatTxtPra"><small>{Veststyle?.description}</small></p>
                                                                                                </div>

                                                                                            </div>
                                                                                        </div>

                                                                                        <div className="col-md-4 addStyleMobileImg">
                                                                                            {
                                                                                                Veststyle?.image ? <Image src={`${ImageUrl}${Veststyle?.image}`} className="noSelectCoatImg" alt="" />
                                                                                                    : <img src="/assets/images/no-photo.png" className="selectCoatImg" alt />

                                                                                            }
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </AccordionItem>
                                                                    <AccordionItem
                                                                        id={5}
                                                                        // title="Tie, Pocket, Jewelry Style"
                                                                        title={<span><strong className="fw-700">Tie, Pocket, Jewelry Style</strong></span>}

                                                                    >
                                                                        <div className="accordion-inner">
                                                                            <div className="row">
                                                                                <div className="col-md-12 p-0 stateSelect">
                                                                                    <div className="row">
                                                                                        <div className="col-md-6 mb-3">
                                                                                            <label>Tie <span className="text-red-500"></span></label>
                                                                                            <Controller
                                                                                                name="GroomMenTie"
                                                                                                control={control}
                                                                                                render={({ field }) => (
                                                                                                    <Select
                                                                                                        {...field}
                                                                                                        options={sortedTie.map(item => ({
                                                                                                            value: item.style,
                                                                                                            label: `${item.style} ${item.description}`
                                                                                                        }))}
                                                                                                        placeholder="Select tie"
                                                                                                        components={customComponents}
                                                                                                        isClearable
                                                                                                        onChange={(selectedOption) => {
                                                                                                            field.onChange(selectedOption ? selectedOption.value : '');
                                                                                                            const syntheticEvent = { target: { value: selectedOption ? selectedOption.value : '' } };
                                                                                                            handleTie(syntheticEvent);
                                                                                                        }}
                                                                                                        value={Tie.map(item => ({
                                                                                                            value: item.style,
                                                                                                            label: `${item.style} ${item.description}`
                                                                                                        })).find(option => option.value === field.value) || null}
                                                                                                    />
                                                                                                )}
                                                                                            />
                                                                                            {errors.Tie && <p className='red'>{errors.Tie.message}</p>}
                                                                                        </div>


                                                                                        <div className="col-md-6 mb-3">
                                                                                            <label>Pocket Square <span className="text-red-500"></span></label>
                                                                                            <Controller
                                                                                                name="GroomMenPocket"
                                                                                                control={control}
                                                                                                render={({ field }) => (
                                                                                                    <Select
                                                                                                        {...field}
                                                                                                        options={sortedPocketSquare.map(item => ({
                                                                                                            value: `${item.style}`,
                                                                                                            label: `${item.style} ${item.description}`
                                                                                                        }))}
                                                                                                        placeholder="Select pocket square"
                                                                                                        components={customComponents}
                                                                                                        isClearable
                                                                                                        onChange={(selectedOption) => {
                                                                                                            field.onChange(selectedOption ? selectedOption.value : '');
                                                                                                            const syntheticEvent = { target: { value: selectedOption ? selectedOption.value : '' } };
                                                                                                            handlePocket(syntheticEvent);
                                                                                                        }}
                                                                                                        value={Pocket.map(item => ({
                                                                                                            value: `${item.style}`,
                                                                                                            label: `${item.style} ${item.description}`
                                                                                                        })).find(option => option.value === field.value) || null}
                                                                                                    />
                                                                                                )}
                                                                                            />
                                                                                            {errors.Pocket && <p className='red'>{errors.Pocket.message}</p>}
                                                                                        </div>

                                                                                        <div className="col-md-6 mb-3">
                                                                                            <label>Jewelry<span className="text-red-500"></span></label>
                                                                                            <Controller
                                                                                                name="GroomMenJewelry"
                                                                                                control={control}
                                                                                                render={({ field }) => (
                                                                                                    <Select
                                                                                                        {...field}
                                                                                                        options={sortedJewelry.map(item => ({
                                                                                                            value: item.style,
                                                                                                            label: `${item.style} ${item.description}`
                                                                                                        }))}
                                                                                                        placeholder="Select jewelry"
                                                                                                        components={customComponents}
                                                                                                        isClearable
                                                                                                        onChange={(selectedOption) => {
                                                                                                            field.onChange(selectedOption ? selectedOption.value : '');
                                                                                                            const syntheticEvent = { target: { value: selectedOption ? selectedOption.value : '' } };

                                                                                                            handlejwellaryChange(syntheticEvent);

                                                                                                        }}
                                                                                                        value={Jewelry.map(item => ({
                                                                                                            value: item.style,
                                                                                                            label: `${item.style} ${item.description}`
                                                                                                        })).find(option => option.value === field.value) || null}
                                                                                                    />
                                                                                                )}
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                    </AccordionItem>
                                                                    <AccordionItem
                                                                        id={6}
                                                                        // title="Shoes Style"
                                                                        title={
                                                                            LebelShoes?.style ? (
                                                                                <span className="fw-400">
                                                                                    <strong className="fw-700">Shoes Style</strong> ({LebelShoes?.style} {LebelShoes?.description})                                                                                </span>
                                                                            ) : (
                                                                                <span><strong className="fw-700">Shoes Style</strong></span>
                                                                            )
                                                                        }
                                                                    >
                                                                        <div className="accordion-inner">
                                                                            <div className="row">
                                                                                <div className="col-md-12 p-0 stateSelect">
                                                                                    <div className="row">
                                                                                        <div className="col-md-8 mb-3">
                                                                                            <div className="row">
                                                                                                <div className="col-md-6 mb-3">
                                                                                                    <label> Shoes Style <span className="text-red-500"></span></label>
                                                                                                    <Controller
                                                                                                        name="GroomMenShoes"
                                                                                                        control={control}
                                                                                                        rules={{ required: false }}
                                                                                                        render={({ field }) => (
                                                                                                            <Select
                                                                                                                {...field}
                                                                                                                options={sortedShoes.map(item => ({
                                                                                                                    value: `${item.style}`,
                                                                                                                    label: `${item.style} ${item.description}`
                                                                                                                }))}
                                                                                                                placeholder="Select shoes"
                                                                                                                components={customComponents}
                                                                                                                isClearable
                                                                                                                onChange={(selectedOption) => {
                                                                                                                    field.onChange(selectedOption ? selectedOption.value : '');
                                                                                                                    const syntheticEvent = { target: { value: selectedOption ? selectedOption.value : '' } };
                                                                                                                    handleShoes(syntheticEvent);
                                                                                                                }}
                                                                                                                value={Shoes.map(item => ({
                                                                                                                    value: `${item.style}`,
                                                                                                                    label: `${item.style} ${item.description}`
                                                                                                                })).find(option => option.value === field.value) || null}
                                                                                                            />
                                                                                                        )}
                                                                                                    />
                                                                                                    {errors.Shoes && <p className='red'>{errors.Shoes.message}</p>}

                                                                                                </div>
                                                                                                <div className="col-md-6 mb-3">
                                                                                                    <h6 className="mb-0 mt-1">{Shoesstyle?.style ? `#${Shoesstyle?.style}` : ''}</h6>
                                                                                                    <p className="coatTxtPra"><small>{Shoesstyle?.description}</small></p>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="col-md-4 addStyleMobileImg">
                                                                                            {
                                                                                                Shoesstyle?.image ? <Image src={`${ImageUrl}${Shoesstyle?.image}`} className="noSelectCoatImg" alt="" />
                                                                                                    : <img src="/assets/images/no-photo.png" className="selectCoatImg" alt />

                                                                                            }
                                                                                        </div></div></div>
                                                                            </div>
                                                                        </div>
                                                                    </AccordionItem>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12">
                                                            <div className="row">
                                                                <div class="col-md-12 mt-3">
                                                                    <a className="backBtnWedding" style={{ cursor: "pointer" }} onClick={handleBack}>Back</a>
                                                                    <button
                                                                        type="submit"
                                                                        className="addBtnCustomer"
                                                                        onClick={() => {
                                                                        }}
                                                                    >
                                                                        Continue
                                                                    </button>                                                                    </div>
                                                            </div>
                                                        </div>
                                                    </div >
                                                </form >
                                            </div >
                                        </div >
                                    </div >
                                </div >
                            </div >
                        </div >
                    </div >
                </div >
            </div >

        </Container >
    )
}

export default GroomsmenStyleDetail
